import { takeEvery, fork, put, all, call } from "redux-saga/effects";
import delay from '@redux-saga/delay-p'

import axios from "axios";

import {
    ACTION_HANDLE_START_FETCHING_NOTIFICATIONS,
    ACTION_MARK_ALL_NOTIFICATIONS_AS_READ,
    ACTION_MARK_NOTIFICATION_AS_READ,
    ACTION_HANDLE_LOAD_MORE_NOTIFICATIONS
} from "./actionTypes";

import {
    markNotificationAsReadLocalList,
    emptyNotificationsList,
    updateNotificationsList,
    updateIsLoadingStatus
} from "./actions";

import {
  MODULES_NOTIFICATIONS_ROUTES
} from "../../common/constants";

import store from "../";

const fetchNotificationListFromRemote = (pageIndex = 1) => {
    return new Promise((resolve, reject) => {
        const { token } = store.getState().Login;
        const { Modules } = store.getState();

        if(!MODULES_NOTIFICATIONS_ROUTES[Modules?.active]?.fetch){
            return (reject("No Notification fetch url!"));
        }

        if (!token) {
            return (reject("NO TOKEN AVAILABLE! Fetching notifications was blocked to prevent 401 errors."));
        }

        axios.get(MODULES_NOTIFICATIONS_ROUTES[Modules?.active].fetch , {
            params: {
                pageIndex: pageIndex,
            },
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
        .then(resolve)
        .catch(reject)
    });
};

const markNotificationAsReadOnRemote = async (id) => {
    const { token } = store.getState().Login;
    const { Modules } = store.getState();

    try {
        const response = await axios.post(
            MODULES_NOTIFICATIONS_ROUTES[Modules.active].markAsRead,
            {
                id: id,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
        );
        return response.data;
    } catch (err) {
        throw err.response.data.error;
    }
};

const markAllNotificationsAsReadOnRemote = async (id) => {
    const { token } = store.getState().Login;
    const { Modules } = store.getState();

    try {
        const response = await axios.post(
            MODULES_NOTIFICATIONS_ROUTES[Modules.active].markAllAsRead,
            {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            },
        );
        return response.data;
    } catch (err) {
        throw err.response.data.error;
    }
};

function* startFetchingNotifications() {
    yield put(emptyNotificationsList());

    while (true) {
        try{
            const {
                data : {
                    data
                }
            } = yield fetchNotificationListFromRemote();

            const { AppNotification } = store.getState();
            
            const totalCount = parseInt(data?.itemsCount || 0);
            const pageSize = parseInt(data?.pageSize || 0);

            if(totalCount !== AppNotification.totalCount || pageSize !== AppNotification.pageSize){
                yield put(updateNotificationsList({
                    totalCount  :   totalCount,
                    pageSize    :   pageSize,
                    list        :   data?.notifications || []
                }))
            }
        }
        catch(err){
            console.log(err)
        }

        yield delay(15000);
    }
}

function* markNotificationAsRead({
    payload : {
        notificationId
    }
}) {
  try {
    yield put(markNotificationAsReadLocalList({notificationId}));
    yield call(markNotificationAsReadOnRemote, notificationId);
  } catch (error) {}
}

function* markAllNotificationsAsRead() {
  try {
    yield put(emptyNotificationsList())
    yield call(markAllNotificationsAsReadOnRemote);
  } catch (error) {}
}

function* loadMoreNotifications() {
    try {
        const { AppNotification } = store.getState();

        yield put(updateIsLoadingStatus({
            status: true
        }));

        try{
            const nextPageIndex = AppNotification.pageIndex + 1;

            const {
                data : {
                    data
                }
            } = yield fetchNotificationListFromRemote(nextPageIndex);

            const nextNotifications = data?.notifications || [];

            if(nextNotifications.length > 0){
                yield put(updateNotificationsList({
                    totalCount  :   parseInt(data?.itemsCount || 0),
                    pageIndex   :   nextPageIndex,
                    list        :   [
                        ...AppNotification.list,
                        ...nextNotifications
                    ]
                }));
            }
        }
        catch(error){
            console.log(error)
        }

        yield put(updateIsLoadingStatus({
            status: false
        }));
    } catch (error) {}
  }

export function* watchMarkAllNotificationsAsRead() {
    yield takeEvery(ACTION_MARK_ALL_NOTIFICATIONS_AS_READ, markAllNotificationsAsRead);
}

export function* watchMarkNotificationAsRead() {
    yield takeEvery(ACTION_MARK_NOTIFICATION_AS_READ, markNotificationAsRead);
}

export function* watchStartFetchingNotifications() {
    yield takeEvery(ACTION_HANDLE_START_FETCHING_NOTIFICATIONS, startFetchingNotifications);
}

export function* watchLoadMoreNotifications() {
    yield takeEvery(ACTION_HANDLE_LOAD_MORE_NOTIFICATIONS, loadMoreNotifications);
}

function* notificationSaga() {
  yield all([
    fork(watchStartFetchingNotifications),
    fork(watchMarkNotificationAsRead),
    fork(watchMarkAllNotificationsAsRead),
    fork(watchLoadMoreNotifications)
  ]);
}

export default notificationSaga;
